import wv from '@cpc/lib-browser-jsapi';
import { browserPartner } from '../../feednews/js/constants';
import { query, jsonParse, getResult } from '@js/utils';
/**
 * 客户端埋点上报方法 https://doc.myoas.com/pages/viewpage.action?pageId=129106137
 * statId：埋点id
 * category：类别
 * module：模块
 * @param {*} data
 * 使用
 * stat({
 *    statId: '20083967',
 *    category: '10009',
 *    module: '23001',
 *    data,
 *   })
 */
export const stat = (data) => {
  let { data: statData } = data;
  if (window.wv.isMethodValid('generalStat')) {
    try {
      statData =
        typeof statData === 'object' && statData
          ? JSON.stringify(statData)
          : JSON.stringify({});
      window.wv.generalStat(data.statId, data.category, data.module, statData);
    } catch (error) {
      console.error(error);
    }
  } else {
    console.error("window.wv.generalStat isn't exist");
  }
};

export const getSession = async () => {
  let session = '';
  if (process.env.NODE_ENV === 'development') {
    session =
      'eyJ5aWRpYW4iOiJKU0VTU0lPTklEPVZwLUJwem44SHhYX1lZVTBYcG96X3c7LTI1NDczMDM5ODgiLCJzIjoib3BwbyIsIm9wcG8iOiJvZnM9ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV5SjFkSGx3SWpveExDSmlkV2xrSWpvek5UTXdNREUyTmprMU1ESTFNREV4TWpBc0ltRjFaQ0k2SW1KeWIzZHpaWElpTENKMlpYSWlPaklzSW5KaGRDSTZNVFU0TlRnNU5UTXpOaXdpZFc1dElqb2lUMUJRVDE4MU5UazRNRGt6T0RRaUxDSnBaQ0k2SWpVMU9UZ3dPVE00TkNJc0ltVjRjQ0k2TVRZMU9UYzJOell4TlN3aVpHTWlPaUowWlhOMEluMC5jZWExNDliclNxekdjWGk2bmI1bTNlRFFDWHlFUGsxRkJWZHE3ZVFJbWxBIiwidG91dGlhbyI6ImFfdD1BVHNMYkdJM2l6UEV3cW0xU2NyTVdIcVp2R3Y2ckp3aHYxWGIyRWhCZXJyWVVtaGVZRHY0REZYWXlvako2Z2RQc1lYNUFtRnVGOzU1OTgwOTM4NCIsImluZm8iOnsicnQiOiIxNjU5MzM1NjE2IiwiZnQiOiIxNTg1ODk1MzM2IiwiZGZ0IjoxNjU5MzM1NjE1LCJ1biI6Ik9QUE9fNTU5ODA5Mzg0IiwidXVpZCI6Ijg2YzBkYjhkNmY5MDY1ZTcwYmI1MmNmYWFkNGVlM2Q0IiwiYnV1aWQiOjM1MzAwMTY2OTUwMjUwMTEwMH19';
  }
  if (wv.isMethodValid('getSession')) {
    session = getResult((await wv.getSession()) || null);
    try {
      if (typeof session === 'object' && session !== null) {
        session = JSON.stringify(session);
        session = window.btoa(session);
      } else {
        session = '';
      }
    } catch (error) {
      console.error(error);
    }
  }
  return session;
};

/**
 * 获取kkua 的header头数据
 */
export const getHeaderKKUA = async () => {
  let headers = {};
  if (process.env.NODE_ENV === 'development') {
    headers['X-KKBrowser-UA-V3'] =
      'KPDBC0CEA02950C92D5AB2D4A1558A1F62eedf1eface501b94cf82e894cf7f0109bkIChMbrsmAeJRg0kxFPujl8mYY1TQ_XIiViKw2xlXfdVk9L7bvS3UdD8iXbcTUOPboFB0-A9ws6dO73uW_P-F0MELK_FYwocua7GqcCY3bWd7xgrM2ilyabre77vA4236GOt3JIw93dfrS82gwoo-AX7iuV6-o4VXAMpkeVlz1nW4MqWh9VRo46OEu1P4ZaZSkdka6d8MlSbQIQg6D15OercBro057HsvQdvw29_kSE_jHda5brKYcU1l2I834NZTdYTvOMyCYhFtNTx2osOaj8gsCiSEX1XvhZFLnnja9PbiMZaUiOicrpnAg4TkG_S5IGmzdJG0N6anWNCJDqfYJ8fXuQk6nIavAUdu4eUX44y_7Sej3ICnIr1p3CmI6Su-UEf5uarsNOuEEEkzyRVDQ9-PFfQx0dQh2D3tRLlMDa-eBNq5jtjo_Zk42naEyeazvExVOZdhoFDOKjL0CI65BDC_i9RW69BpU4Kl3cHrA8MB_HkF2CBRbPuZpiTPyr_GhECXjc6M37Hb8ux9C3NKr4_fyW1rOwwakSeiOF9jYSnVKNGcORnuwfufV2CKt_JGUqk8SvU_rr4ommXuOhtO11a1PVd1bKC28xsGPTARJ18_ssB8dYGH_s9r7sOjDOmfx6h57UhwopsTQmRGMY6Qe1iM5tKqu6ZZx-z4cl1z1ZDwVxZ0jXZiMFr6_Rvj4xqLjfuG6mY3-6IdarpIBs7Jhmfpk1NS7YufJNIippk2M';
  }
  if (typeof wv !== 'undefined') {
    if (wv.isMethodValid('getKKUAV3')) {
      headers['X-KKBrowser-UA-V3'] = getResult((await wv.getKKUAV3()) || null);
    } else if (wv.isMethodValid('getKKUAV2')) {
      headers['X-KKBrowser-UA-V2'] = getResult((await wv.getKKUAV2()) || null);
    } else if (wv.isMethodValid('getKKUA')) {
      headers['X-KKBrowser-UA'] = getResult((await wv.getKKUA()) || null);
    }
  }
  return headers;
};

export const openDeepLink = (link) => {
  if (window.OppoWebPage && window.OppoWebPage.openDeepLink) {
    return window.OppoWebPage.openDeepLink(link);
  } else {
    return window.open(link);
  }
};

//  获取归因参数
export const getBizTraceInfo = () => {
  try {
    const { data } = window?.wv?.invoke?.('BrowserIFlow.getBizTraceInfo');
    return data;
  } catch (error) {
    return {};
  }
};

export function bizTraceCacheSet(key, value) {
  try {
    const config =
      window.wv?.getConfigValue?.('CommonConfig_bizTraceCacheTime')?.data || {};
    const max = config.max || 1000;
    const curtime = new Date().getTime();
    let cacheArr =
      localStorage.getItem('__transparent__cache__') || JSON.stringify([]);
    cacheArr = JSON.parse(cacheArr);
    if (cacheArr.length >= max) {
      cacheArr.splice(0, 1);
    }
    let item = cacheArr.find((i) => i.key == `__transparent__cache__${key}`);
    if (item) {
      item.value = value;
      item.time = curtime;
    } else {
      item = { key: `__transparent__cache__${key}`, value, time: curtime };
    }
    cacheArr.push(item);
    localStorage.setItem('__transparent__cache__', JSON.stringify(cacheArr));
  } catch (error) {
    console.error('bizTraceCacheSet is error', error);
  }
}

export function bizTraceCacheGet(key) {
  try {
    const config =
      window.wv?.getConfigValue?.('CommonConfig_bizTraceCacheTime')?.data || {};
    const exp = config.expire || 0;
    const val = localStorage.getItem('__transparent__cache__');
    if (!val) return '';
    const dataObj = JSON.parse(val);
    const hasKey = dataObj.find((i) => i.key == `__transparent__cache__${key}`);
    if (!exp || !hasKey) return '';
    //如果当前时间-减去存储的元素在创建时候设置的时间 > 过期时间
    if (new Date().getTime() - hasKey.time > exp * 1000) {
      const index = dataObj.findIndex((i) => i.key == dataObj.key);
      if (index > -1) {
        dataObj.splice(index, 1);
      }
      localStorage.setItem('__transparent__cache__', JSON.stringify(dataObj));
      return '';
    } else {
      return hasKey;
    }
  } catch (error) {
    console.error('bizTraceCacheGet is error:', error);
    return '';
  }
}

/**
 * 获取保存到客户端中的数据
 * @param {*} str
 * @returns
 */
export function getCommonSaveConfig(name) {
  if (window.BrowserIFlow?.getCommonSaveConfig) {
    console.log('commonSaveConfig data', name);
    return jsonParse(window.BrowserIFlow.getCommonSaveConfig(name));
  }
  return {};
}

// 获取客户端存储的归因
export function getClientCacheBizTrace(docid) {
  try {
    const transparent = getCommonSaveConfig('h5_sdk_bizTrace') || {};
    if (!transparent.docId || transparent.docId != docid) return '';
    console.log('getClientCacheBizTrace1', transparent);
    return transparent;
  } catch (error) {
    console.error('getClientCacheBizTrace is error', error);
    return {};
  }
}

/**
 * 将数据保存到客户端中
 * @param {*} str
 * @returns
 */
export function commonSaveConfig(name, data) {
  if (window.BrowserIFlow?.commonSaveConfig) {
    const dataString = JSON.stringify(data);
    return window.BrowserIFlow.commonSaveConfig(name, dataString);
  }
}

// 天气信息流上报归因字段对象
export function weatherBizTracReport() {
  try {
    let bizTraceInfo = {};
    console.log('browserPartner', browserPartner);
    if (browserPartner == 'weather') {
      if (bizTraceCacheGet(query.get('__docId__'))?.value?.transparent) {
        const data = bizTraceCacheGet(query.get('__docId__')).value;
        bizTraceInfo.bizTraceId = data.id;
        bizTraceInfo.bizTraceTransparent = data.transparent;
      } else if (getBizTraceInfo?.().transparent) {
        const data = getBizTraceInfo();
        bizTraceInfo.bizTraceId = data.id;
        bizTraceInfo.bizTraceTransparent = data.transparent;
      } else if (getClientCacheBizTrace(query.get('__docId__')).transparent) {
        const data = getClientCacheBizTrace(query.get('__docId__'));
        bizTraceInfo.bizTraceId = data.id;
        bizTraceInfo.bizTraceTransparent = data.transparent;
      }
    }
    return bizTraceInfo;
  } catch (error) {
    console.error('weatherBizTracReport is error', error);
    return {};
  }
}
